module.exports = __webpack_public_path__ + "img/payments.weekly.b32a885e.png";